import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card, CardContent, Chip, FormControl, InputAdornment, InputLabel, OutlinedInput} from "@mui/material";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import {getInventoryItem, removeTag, saveInventory, saveTag} from "../common/api/InventoryApi";
import {useNavigate, useParams} from "react-router-dom";
import MDTypography from "../../components/MDTypography";
import Grid from "@mui/material/Grid";
import MDButton from "../../components/MDButton";
import Divider from "@mui/material/Divider";
import {Col, Row} from "react-bootstrap";
import {formatCurrency} from "../common/Utils";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import {CONSTANTS} from "../common/constants";
import {useForm} from "react-hook-form";
import PageLoading from "../common/PageLoading";
import ManageInventoryModal from "./ManageInventoryModal";

export default function ViewInventory(props) {

  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  let {guid} = useParams();

  const [cafeMode, setCafeMode] = useState(false);

  const [reloadInventory, setReloadInventory] = useState(false);
  const [inventory, setInventory] = useState();
  const [modalInventory, setModalInventory] = useState();

  const [inventoryReady, setInventoryReady] = useState(false);
  const [renderIndex, setRenderIndex] = useState(1);

  const [refreshCart, setRefreshCart] = useState(false);
  const [refreshReservations, setRefreshReservations] = useState(false);
  const [viewingCart, setViewingCart] = useState(false);
  const [saving, setSaving] = useState(false);

  const [client, setClient] = useState(null);

  const myRefs = useRef([]);

  const [listCustomersModalOpen, setListCustomersModalOpen] = useState(false);
  const [listCustomersWaitlistModalOpen, setListCustomersWaitlistModalOpen] = useState(false);

  const handleCloseListCustomersModal = () => {
    setListCustomersModalOpen(false);
  }

  const handleCloseListWaitlistCustomersModal = () => {
    setListCustomersWaitlistModalOpen(false);
  }

  const startAddCustomerReservation = () => {
    setListCustomersModalOpen(true);
  }

  const startAddCustomerWaitlist = () => {
    setListCustomersWaitlistModalOpen(true);
  }

  const getInventoryFn = async (guid) => {
    return await getInventoryItem(guid);
  }
  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const toggleCartFn = () => {
    setViewingCart(!viewingCart);
  }

  const [tagName, setTagName] = useState('');
  const [tags, setTags] = useState([]);
  const [showTags, setShowTags] = useState(false);
  const toggleTagsFn = () => {
    setShowTags(!showTags);
  }

  const handleTagChange = (e) => {
    setTagName(e.target.value);
  }

  const removeTagFn = async (tag, index) => {
    removeTag(tag).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTags(tags.filter((t, i) => i !== index))
      }
    });
  }
  const saveTagFn = async () => {
    let tag = {
      name: tagName,
      entityType: CONSTANTS.ENTITY_TYPE.INVENTORY,
      entityId: inventory.id,
    }
    saveTag(tag).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTagName('');
        setTags([...tags, result]);
      }
    });
  }

  const handleEditInventory = () => {
    let _inventory = {...inventory};
    setModalInventory(_inventory);
    setManageInventory(true);
  }

  const {register, handleSubmit, setValue} = useForm({});

  const closeInventoryFn = () => {
    setInventory(null);
    setManageInventory(false);
  }

  const handleSaveInventory = async (inventory) => {
    const inv = {...inventory};
    let result = await saveInventory(inv);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryFn();
      setReloadInventory(true);
    }
  }

  const [manageInventory, setManageInventory] = useState(false);

  const handleCloseInventory = () => {
    setManageInventory(false);
  }

  useEffect(() => {
    if (!guid) {
      return;
    }
    getInventoryFn(guid).then(result => {
      setInventory(null);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventory(result);
        setCafeMode(result?.inventoryType?.cafeItem)
        setTags(result.tags);
        setInventoryReady(true);
      }
    });
  }, [guid]);

  useEffect(() => {
    if (!reloadInventory) {
      return;
    }
    setReloadInventory(false);
    getInventoryFn(guid).then(result => {
      setInventory(null);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventory(result);
        setTags(result.tags);
        setInventoryReady(true);
      }
    });
  }, [reloadInventory]);

  return (
    <DashboardLayout>

      <ContextSearchNavbar title={'View Retail'}/>
      {!inventoryReady && <PageLoading/>}
      {inventoryReady && <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={3}>

            <Grid item xs={12} md={cafeMode ? 7 : 12}>
              <Card>
                <CardContent>
                  <div className={'pull-right'} ref={el => (myRefs.current['inventoryActions'] = el)}
                       onClick={(e) => {
                         refHandler('inventoryActions')
                       }}>

                    <MDButton
                      variant="outlined"
                      color="secondary"
                      size="small"
                      circular
                      iconOnly
                    >
                      <Icon>more_horiz</Icon>
                    </MDButton>
                    {renderIndex && myRefs.current['inventoryActions']?.visible &&
                      <Menu open={true} anchorReference={null} anchorEl={myRefs.current['inventoryActions']}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}>

                        <NotificationItem
                          onClick={(e) => {
                            handleEditInventory()
                          }} icon={<Icon>edit</Icon>} title="Copy"/>

                        <NotificationItem
                          onClick={(e) => {
                            handleEditInventory()
                          }} icon={<Icon>edit</Icon>} title="Edit"/>

                      </Menu>
                    }
                  </div>
                  {inventory?.name &&
                    <>
                      <h4 className={'mt-2'}>{inventory?.name}</h4>
                    </>
                  }

                  <Row>
                    <Col sm={12} md={6}>
                      {inventory?.inventoryType?.name && <>
                        <h6>Inventory Type</h6>
                        <p>{inventory?.inventoryType?.name}</p>

                        <h6>Status</h6>
                        <p>{inventory?.status?.name}</p>

                      </>
                      }
                    </Col>
                    <Col sm={12} md={6}>
                      {inventory?.brand?.name && <>
                        <h6>Brand</h6>
                        <p>{inventory?.brand?.name}</p>
                      </>
                      }
                    </Col>
                  </Row>
                  <Divider/>

                  <Row>
                    <Col sm={4}>
                      <h6>
                        {inventory?.giftCard ? 'Minimum Amount' : 'Price'}
                      </h6>
                      <p>
                        {inventory?.giftCard && formatCurrency(inventory?.minAmount)}
                        {!inventory?.giftCard && formatCurrency(inventory?.price)}
                      </p>

                      <h6>Available</h6>
                      <p>
                        {inventory?.unlimited ? 'Unlimited' : inventory?.quantity}
                      </p>

                    </Col>
                    <Col sm={4}>

                      <h6>
                        {inventory?.giftCard ? 'Maximum Amount' : 'Wholesale Price'}
                      </h6>
                      <p>
                        {inventory?.giftCard && formatCurrency(inventory?.maxAmount)}
                        {!inventory?.giftCard && formatCurrency(inventory?.wholesalePrice)}
                      </p>

                    </Col>

                  </Row>
                  <Divider/>
                  <Row>
                    <Col sm={12}>
                      <MDTypography fontWeight={'bold'} variant={'h6'}>Description</MDTypography>
                      <p style={{
                        fontWeight: '100',
                        whiteSpace: 'pre-wrap',
                        borderLeft: 'solid 2px #ddd',
                        paddingLeft: '5px',
                        paddingRight: '40px'
                      }}>
                        {inventory?.desc}
                      </p>
                    </Col>
                  </Row>

                  <Divider/>

                  <Row>
                    <Col sm={12}>
                      <MDTypography fontWeight={'bold'} variant={'h6'}>
                        <Icon>tag</Icon>&nbsp;Tags
                        <Chip
                          label={!showTags ? 'Add Tag' : 'Close'}
                          icon={!showTags ? <Icon>add_circle</Icon> : <Icon>cancel</Icon>}
                          color="primary"
                          className="pull-right"
                          size="small"
                          onClick={() => {
                            toggleTagsFn()
                          }}
                        /></MDTypography>
                      {tags?.length > 0 && tags.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1).map((tag, index) => {
                        return (
                          <span key={index}>
                           <Chip
                             label={tag.name}
                             onDelete={() => {
                               removeTagFn(tag, index);
                             }}
                             color="primary"
                             variant="outlined"
                           />&nbsp;
                         </span>
                        )
                      })
                      }

                      {showTags && <form onSubmit={handleSubmit(saveTagFn)}>
                        <FormControl variant="outlined" p={0}
                                     className="form-inline d-block mt-4">
                          <InputLabel htmlFor="tag-input">Tag</InputLabel>
                          <OutlinedInput
                            autoFocus
                            id="tag-input"
                            type={'text'}
                            value={tagName}
                            onChange={handleTagChange}

                            endAdornment={
                              <InputAdornment position="end">
                                <MDButton
                                  color="primary"
                                  size="small"
                                  disabled={!tagName}
                                  onClick={handleSubmit(saveTagFn)}
                                  className={'btn btn-primary'}
                                >Save</MDButton>
                              </InputAdornment>
                            }
                            label="Tag"
                          />
                        </FormControl>
                      </form>
                      }
                    </Col>
                  </Row>

                  <Divider/>

                  <Row>
                    <Col sm={6}>
                      <MDTypography fontWeight={'bold'} variant={'h6'}>Public Image</MDTypography>
                      {inventory?.imageUrl && <img
                        className={'mt-2 img-thumbnail'} src={inventory?.imageUrl} alt="img"/>}
                    </Col>
                    {inventory?.giftCard && inventory?.backgroundImageUrl && <>
                      <Col sm={6}>
                        <h5>Background Image</h5>
                        {inventory?.backgroundImageUrl && <img
                          className={'mt-2 img-thumbnail'} src={inventory?.backgroundImageUrl} alt="img"/>}
                      </Col>
                    </>}

                  </Row>
                </CardContent>
              </Card>
            </Grid>


            {cafeMode &&
              <Grid item sm={12} md={5}>
                <Card>
                  <CardContent>
                    <h5>Cafe Options</h5>
                    {inventory?.cafeGroups?.length > 0 &&
                      <>
                        {inventory?.cafeGroups?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((group, idx) => {
                          return (
                            <div key={idx}>
                              <b>{group.optionGroupName}</b>
                              <span style={{
                                display: 'block',
                              }}>
                                  <small>
                                    {group.options?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((opt, idx) => {
                                      return <span key={idx}>{idx === 0 ? '' : ', '}{opt.optionName}</span>
                                    })}
                                  </small>
                                </span>
                            </div>
                          )
                        })
                        }
                      </>
                    }
                  </CardContent>
                </Card>
              </Grid>
            }

          </Grid>


        </MDBox>
      </MDBox>
      }

      {manageInventory && <ManageInventoryModal
        inventory={inventory}
        show={modalInventory}
        giftCard={inventory?.giftCard}
        saving={saving}
        cafeMode={cafeMode}
        handleSave={handleSaveInventory}
        handleClose={handleCloseInventory}/>}

      <Footer mt={5}/>
    </DashboardLayout>
  );
}